import { SetStateAction, Dispatch, useEffect, useState, useRef } from "react";
import { CompleteArray } from "../../../types/FlowTemplates";
import { toast } from "react-toastify";

export default function EditableField({
  el,
  idx,
  steps,
  setSteps,
}: {
  el: CompleteArray;
  idx: number;
  steps: CompleteArray[];
  setSteps: Dispatch<SetStateAction<CompleteArray[]>>;
}) {
  const [isEditable, setIsEditable] = useState(false);
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (isEditable && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditable]);

  const handleEnter = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key !== "Enter") return;

    const newValue = e.currentTarget.value.trim();

    if (!newValue) {
      toast.warning("Step can not be empty");
      return;
    }

    const updated = [...steps];
    updated[idx].step.field = newValue;
    setSteps(updated);

    setIsEditable(false);
  };

  const handleBlur = (e: React.FocusEvent<HTMLTextAreaElement, Element>) => {
    const newValue = e.currentTarget.value.trim();

    if (!newValue) {
      toast.warning("Step can not be empty");
      return;
    }

    const updated = [...steps];
    updated[idx].step.field = newValue;
    setSteps(updated);

    setIsEditable(false);
  };

  return isEditable ? (
    <textarea
      ref={inputRef}
      defaultValue={el.step.field}
      onBlur={handleBlur}
      onKeyDown={handleEnter}
      className="text-xs text-center px-2 py-1 border border-gray-300 rounded w-full"
      required
      minLength={2}
    ></textarea>
  ) : (
    <p
      className="text-xs w-full"
      onClick={() => {
        if (["Shipment Pickup", "Shipment Booking"].includes(el.step.field)) {
          toast.warning("You can't edit this step");
        } else {
          setIsEditable(true);
        }
      }}
    >
      {el.step.field}
    </p>
  );
}
